import type { LangCode } from 'src/locales';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { allLangs, useTranslate } from 'src/locales';

import { FlagIcon } from 'src/components/flag-icon';

// ----------------------------------------------------------------------

const GUEST_LANGUAGES: { value: LangCode; nativeName: string }[] = [
  { value: 'en', nativeName: 'English' },
  { value: 'he', nativeName: 'עברית' },
];

export function GuestLanguageSwitch() {
  const { t, currentLang, onChangeLang } = useTranslate();

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={currentLang.value}
      aria-label={t('guest.common.language')}
      onChange={(_event, lang: LangCode | null) => {
        if (lang) {
          onChangeLang(lang);
        }
      }}
    >
      {GUEST_LANGUAGES.map((language) => (
        <ToggleButton
          key={language.value}
          value={language.value}
          lang={language.value}
          sx={{
            gap: 0.75,
            px: 1.25,
            py: 0.5,
            typography: 'caption',
            fontWeight: 'fontWeightSemiBold',
          }}
        >
          <FlagIcon
            code={allLangs.find((option) => option.value === language.value)?.countryCode}
            sx={{ width: 18, height: 14 }}
          />
          {language.nativeName}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
